import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { CategorizacionService } from 'src/app/services/panelM/update-params/categorizacion.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { NestedTreeControl } from '@angular/cdk/tree';

@Component({
  standalone: false,
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent implements OnInit {

  treeControl = new NestedTreeControl<any>(node => node.Child_Nodes);
  params = new MatTreeNestedDataSource<any>();
  tab = 1;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private categoriesS: CategorizacionService, private readonly router: Router, private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.categoriesS.categorizacionService().subscribe((data: any) => {
      this.params.data = data.MovementsList;
    }, error => {
      console.error(error);
      this.router.navigateByUrl('/portalM');
    });
  }

  hasChild = (_: number, node: any) => !!node.Child_Nodes && node.Child_Nodes.length > 0;

  updateRow(element) {
    this.categoriesS.updateCategorizacion(element).subscribe((data: any) => {
      this.snackBar.open((data.Ok) ? 'Actualización correcta' : 'Error al actualizar', '', {
        duration: 1000,
      });
    }, (data) => {
      this.snackBar.open((data.Ok) ? 'Actualización correcta' : 'Error al actualizar', '', {
        duration: 1000,
      });
    });
  }

  updateRowNode(element) {
    this.categoriesS.updateCategorizacion(element).subscribe((data: any) => {
      this.snackBar.open((data.Ok) ? 'Actualización correcta' : 'Error al actualizar', '', {
        duration: 1000,
      });
    }, (data) => {
      this.snackBar.open((data.Ok) ? 'Actualización correcta' : 'Error al actualizar', '', {
        duration: 1000,
      });
    });
  }

  changeTab = (num) => {
    this.tab = num;
  }
}
